import { FilterLiveSearch, useListContext, FilterList, FilterListItem } from "react-admin";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { createStyles, makeStyles, Card, CardContent } from "@material-ui/core";
import {
  FixedDateRangeFilterList,
} from "../../../lib/common";
import {
  format,
  endOfYesterday,
  startOfWeek,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import { FILTER_DIRECTION, ProcEntityRecordStatusFilterList, ProcureApprovalStatusFilterList } from "../../../common";
import ApproveIcon from "@material-ui/icons/ThumbUpAltTwoTone";


const BidListSideFilters = (props) => {
  const cardClasses = useCardStyles();
  const { filterValues } = useListContext(props);
  const isDirectionReceived = filterValues?.direction === FILTER_DIRECTION.RECEIVED;

  return (
    <Card classes={cardClasses}>
      <CardContent>
        <FilterLiveSearch />
        <FixedDateRangeFilterList
          label="resources.bids.fields.updated_since_gte"
          icon={<AccessTimeIcon />}
          gteSource="updated_since_gte"
          lteSource="updated_since_lte"
          dateRangeList={updatedSinceDatesList}
        />
        {isDirectionReceived && <ProcEntityRecordStatusFilterList />}
        {isDirectionReceived && <ProcureApprovalStatusFilterList /> }
        {isDirectionReceived && <FilterList
          label="resources.bids.fields.needsUserApproval"
          icon={<ApproveIcon />}
        >
          <FilterListItem
            label="ra.boolean.true"
            value={{ needsUserApproval: true }}
          />
          <FilterListItem
            label="ra.boolean.false"
            value={{ needsUserApproval: false }}
          />
        </FilterList>}
      </CardContent>
    </Card>
  );
};

const useCardStyles = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.up("sm")]: {
        order: -1,
        maxWidth: 210,
        marginRight: "1em",
      },
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  })
);

const DATE_FORMAT_DAY = "yyyy-MM-dd";
const updatedSinceDatesList = [
  {
    label: "resources.bids.filters.updatedSince.today",
    gte: format(endOfYesterday(), DATE_FORMAT_DAY),
    lte: undefined,
  },
  {
    label: "resources.bids.filters.updatedSince.thisWeek",
    gte: format(startOfWeek(new Date()), DATE_FORMAT_DAY),
    lte: undefined,
  },
  {
    label: "resources.bids.filters.updatedSince.thisMonth",
    lte: undefined,
    gte: format(startOfMonth(new Date()), DATE_FORMAT_DAY),
  },
  {
    label: "resources.bids.filters.updatedSince.lastMonth",
    lte: format(endOfMonth(subMonths(new Date(), 1)), DATE_FORMAT_DAY),
    gte: format(subMonths(startOfMonth(new Date()), 1), DATE_FORMAT_DAY),
  },
  {
    label: "resources.bids.filters.updatedSince.earlier",
    lte: format(endOfMonth(subMonths(new Date(), 2)), DATE_FORMAT_DAY),
    gte: undefined,
  },
];

export { BidListSideFilters };
